module.exports = __webpack_public_path__ + "static/media/banner.7365d00c.png";